import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ThemeService {
  private readonly THEME_KEY = "theme";

  initTheme(): void {
    const savedTheme = localStorage.getItem(this.THEME_KEY) || "light";
    document.body.setAttribute("theme", savedTheme);
  }

  setTheme(theme: "light" | "dark"): void {
    if ("startViewTransition" in document) {
      (document as any).startViewTransition(() => {
        this._setTheme(theme);
      });
      return;
    }
    this._setTheme(theme);
  }

  getTheme(): "light" | "dark" {
    return (localStorage.getItem(this.THEME_KEY) as "light" | "dark") || "light";
  }

  private _setTheme(theme: "light" | "dark") {
    localStorage.setItem(this.THEME_KEY, theme);
    document.body.setAttribute("theme", theme);
  }
}
